import script from "./Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Form.vue?vue&type=script&setup=true&lang=js"

import "./Form.vue?vue&type=style&index=0&id=0b1b9dc8&lang=scss"

const __exports__ = script;

export default __exports__